__turbopack_context__.v({
  "className": "roboto_condensed_7d3e161-module__RcVQ7W__className",
  "variable": "roboto_condensed_7d3e161-module__RcVQ7W__variable",
});
